// export const GET_ALL_DATA_SUCCESS = "all_Data/get/success";

export const GET_PRODUCTS_LOADING = "product/get/loading";
export const GET_PRODUCTS_SUCCESS = "product/get/success";
export const GET_PRODUCTS_ERROR = "product/get/error";

export const ADD_PRODUCTS_SUCCESS = "ADD_PRODUCTS_SUCCESS";

export const ADD_WISHLIST_SUCCESS = "ADD_WISHLIST_SUCCESS";

export const GET_CART_DATA = "GET_CART_DATA";
